// Campus photo for /colleges/northwestern-university: Public domain, by Daderot, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ANorthwestern_University_Library%2C_Evanston%2C_IL.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/northwestern-university/; credited under the photo.
const photo = {
    "slug": "northwestern-university",
    "alt": "The concrete towers of Northwestern University Library on a summer day on the Evanston, Illinois campus",
    "src": "/colleges/northwestern-university/campus-1600.webp",
    "srcSmall": "/colleges/northwestern-university/campus-800.webp",
    "srcMid": "/colleges/northwestern-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/northwestern-university/og.jpg",
    "title": "Northwestern University Library, Evanston, IL",
    "author": "Daderot",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ANorthwestern_University_Library%2C_Evanston%2C_IL.JPG",
    "read": "2026-10-01"
};

export default photo;
